import {
  cloud,
  Wildfire,
  Flood,
  Tornado,
  Heat,
  Dust,
  Wind,
  Snowstorm,
  Freeze,
  Thunderstorm,
  Rain,
  Fog,
  NonWeatherAlert,
} from '../../../../assets/images/map/index';
import type { HazardIconKey } from './hazardPresentation';

/**
 * Resolves the semantic icon keys produced by `hazardPresentation` to the
 * bundled assets. Kept apart from the presentation rules so those stay pure
 * and both map providers share one key-to-asset mapping.
 */
const HAZARD_ICON_BY_KEY: Record<HazardIconKey, string> = {
  wildfire: Wildfire,
  flood: Flood,
  tornado: Tornado,
  extremeHeat: Heat,
  dustStorm: Dust,
  highWind: Wind,
  snowstorm: Snowstorm,
  freeze: Freeze,
  severeThunderstorm: Thunderstorm,
  heavyRain: Rain,
  heavyFog: Fog,
  nonWeather: NonWeatherAlert,
  cloud,
};

export const getHazardIconUrl = (key: HazardIconKey): string =>
  HAZARD_ICON_BY_KEY[key];
